export default "__VITE_ASSET__BE23auVc__"